'use client';

import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import StatusScreen from '@/components/StatusScreen';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return <StatusScreen title="The story paused" message="Something went wrong while loading this page. Try again to get back to your table." actionLabel="Try again" onAction={reset} />;
}
